"use client";
import { styled } from "@mui/material/styles";
const StyledListItem = styled("li")(() => ({}));
export {
  StyledListItem
};
